import { AxiosRequestConfig, AxiosResponse } from 'axios';
import config from 'config';
import { parseRotatingSegmentTitles, ParsedRotatingSegmentTitles } from 'models/rotatingSegmentTitles';
import querystring from 'querystring';
import {
  HttpClient,
  QueryOptions,
} from './api-types';

const API_URL = config.api.rotatingSegmentTitlesApiUrl;

const queryApi = (
  httpClient: HttpClient,
  url: string,
  options?: QueryOptions,
): Promise<AxiosResponse> => {
  const request: AxiosRequestConfig = {
    url,
    method: options && options.data ? 'post' : 'get',
  };

  if (options) {
    if (options.params) request.params = options.params;
    request.headers = {
      ...request.headers,
      ...options.headers,
    };
    if (options.data) {
      request.data = querystring.stringify(
        options.data as querystring.ParsedUrlQueryInput,
      );
      request.headers = {
        ...request.headers,
        'content-type': 'application/x-www-form-urlencoded',
      };
    }
  }

  return httpClient(request);
};

export const fetchRotatingSegmentTitlesApi = async (
  httpClient: HttpClient,
): Promise<ParsedRotatingSegmentTitles> => {
  const response = await queryApi(httpClient, API_URL);
  const { data: result } = response;
  return parseRotatingSegmentTitles(result);
};
